import { Component, OnInit } from '@angular/core';
// Activated Route
import { ActivatedRoute } from '@angular/router';

import { UserService, TrabajosInvitadosService, TranslationService } from '../../services/services.index';
import * as jspdf from 'jspdf';
import * as html2canvas from 'html2canvas';

declare function init_plugins();

@Component({
  selector: 'app-certificados-mesas',
  templateUrl: './certificados-mesas.component.html',
  styles: []
})
export class CertificadosMesasComponent implements OnInit {

  mesa: any;

  constructor(public _userService: UserService,
    private activatedRoute: ActivatedRoute,
    public _trabajosInvitadosService: TrabajosInvitadosService,
    public _translationService: TranslationService) { }

  ngOnInit() {
    init_plugins();
    this.activatedRoute.params.subscribe( params => {
      let mesaId: any = params['mesa'];
      this._trabajosInvitadosService.getTrabajoPorId(mesaId).subscribe((resp: any) => {
        this.mesa = resp;
      });
    });
  }

  generarPdf() {
    let data = document.getElementById('contentToConvert');
    html2canvas(data).then(canvas => {
    // Few necessary setting options
    let imgWidth = 295;
    let pageHeight = 295;
    let imgHeight = canvas.height * imgWidth / canvas.width;
    let heightLeft = imgHeight;

    const contentDataURL = canvas.toDataURL('image/png');
    let pdf = new jspdf('l', 'mm', 'a4'); // A4 size page of PDF
    let position = 0;
    pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
    pdf.save('certificado-mesa.pdf'); // Generated PDF
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/certificados/certificados-mesas/certificados-mesas.component.ts